
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const MonthlyWorkanalysisReportTableDataAPI = createAsyncThunk("MonthlyWorkanalysisReportTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_WardID,
        M_WorkTypeID,
        M_AssetTypeID,
        M_AssetID,
        M_UserID,
        Flag,
        token,
        handleGetPDFUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_Month_Wise_WorkAssign_CompletedAnalysis_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_WardID=${M_WardID}&M_WorkTypeID=${M_WorkTypeID}&M_AssetTypeID=${M_AssetTypeID}&M_AssetID=${M_AssetID}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)
    // return fetch(`https://apinmmcdaksha.cdat.work/APKDashboard/Get_RM_Month_Wise_WorkAssign_CompletedAnalysis_Select?M_FinancialYearID=2025&M_MonthID=0&M_WardID=1&M_WorkTypeID=1&M_AssetTypeID=1&M_AssetID=0&M_UserID=1&Flag=Master`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                handleGetPDFUrl(result?.url)
                return result.data
            } else {
                return result
            }
        })
})

const MonthlyWorkanalysisReportTableDataSlice = createSlice({
    name: "MonthlyWorkanalysisReportTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MonthlyWorkanalysisReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MonthlyWorkanalysisReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(MonthlyWorkanalysisReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const MonthlyWorkanalysisReportTableDataReducer = MonthlyWorkanalysisReportTableDataSlice.reducer